import React, { useState, useEffect } from 'react';
import MetaPageSelect from './MetaPageSelect';
import axios from 'axios';
import { T, MONO, alpha } from './poyais-ui/theme';
import { useLang, addTranslations } from './i18n';
import PoyaisSpinner from './PoyaisSpinner';

addTranslations({
  'Yeni Kampanya': 'New Campaign',
  'Yeni Kampanya Oluştur': 'Create New Campaign',
  'Kampanya Düzenle': 'Edit Campaign',
  'Havuza Dön': 'Back to Pool',
  'Taslak': 'Draft',
  'Onay Bekliyor': 'Pending Approval',
  'Onaylandı': 'Approved',
  'Reddedildi': 'Rejected',
  'Yayında': 'Live',
  'Yayında Aktif': 'Live & Active',
  'Durduruldu': 'Paused',
  'Toplam': 'Total',
  'Yükleniyor…': 'Loading…',
  'Henüz kampanya taslağı yok': 'No campaign drafts yet',
  'Yeni kampanya oluşturmak için butona tıklayın.': 'Click the button to create a new campaign.',
  'gün': 'day',
  'Onaya Gönder': 'Submit for Approval',
  'Onayla': 'Approve',
  'Reddet': 'Reject',
  "Meta'ya Yayınla": 'Publish to Meta',
  "Google Ads'e Yayınla": 'Publish to Google Ads',
  "ChatGPT Ads'e Yayınla": 'Publish to ChatGPT Ads',
  "Criteo'ya Yayınla": 'Publish to Criteo',
  'Gönderiliyor…': 'Sending…',
  'İşleniyor…': 'Processing…',
  'Durdur': 'Pause',
  'Aktif Et': 'Activate',
  'Platformda Aç': 'Open on Platform',
  'Düzenle': 'Edit',
  'Hata Oluştu': 'Error Occurred',
  'Tamam': 'OK',
  "Kampanya PAUSED olarak oluşturuldu. Meta Ads Manager'dan creative ekleyip aktif edebilirsiniz.": "The campaign was created as PAUSED. You can add a creative and activate it from Meta Ads Manager.",
  "Kampanya paused olarak oluşturuldu. OpenAI Ads Manager'dan kontrol edip aktif edebilirsiniz.": "The campaign was created as paused. You can review and activate it from OpenAI Ads Manager.",
  "Kampanya PAUSED olarak oluşturuldu. Google Ads'ten anahtar kelime ekleyip aktif edebilirsiniz.": "The campaign was created as PAUSED. You can add keywords and activate it from Google Ads.",
  "Kampanya PAUSED olarak oluşturuldu.": "The campaign was created as PAUSED.",
  "Criteo Management Center'dan kontrol edip aktif edebilirsiniz.": "You can review and activate it from Criteo Management Center.",
  "Google Ads'ten kontrol edip aktif edebilirsiniz.": "You can review and activate it from Google Ads.",
  "anahtar kelime eklendi.": "keyword(s) added.",
  "Anahtar kelime girilmedi. Yayına almadan önce Google Ads'ten eklemeniz gerekir.": "No keywords were entered. You must add them in Google Ads before activating.",
  "Bilinmeyen bir hata oluştu": "An unknown error occurred",
  'Platform': 'Platform',
  'Hedef': 'Target',
  'Kitle & Bütçe': 'Audience & Budget',
  'Reklam': 'Ad',
  'Özet': 'Summary',
  'İptal': 'Cancel',
  '← Geri': '← Back',
  'Devam Et →': 'Continue →',
  'Taslak Kaydet': 'Save Draft',
  'Kaydediliyor…': 'Saving…',
  'Onaya Gönder →': 'Submit for Approval →',
  'Platform Seç': 'Select Platform',
  'Kampanyanızı hangi platformda yayınlamak istiyorsunuz?': 'Which platform do you want to publish your campaign on?',
  'Facebook & Instagram reklamları': 'Facebook & Instagram ads',
  'Arama reklamları': 'Search ads',
  'ChatGPT sohbet içi reklamlar': 'In-chat ChatGPT ads',
  'Dinamik yeniden pazarlama reklamları': 'Dynamic retargeting ads',
  'YAKINDA': 'COMING SOON',
  'BAĞLI DEĞİL': 'NOT CONNECTED',
  '✓ Seçildi': '✓ Selected',
  'Kampanya Adı': 'Campaign Name',
  'Örn: Yaz Koleksiyonu 2026': 'e.g. Summer Collection 2026',
  'Kampanya Hedefi': 'Campaign Objective',
  'Bu kampanya ile ne elde etmek istiyorsunuz?': 'What do you want to achieve with this campaign?',
  'Satış': 'Sale',
  'Lead': 'Lead',
  'Trafik': 'Traffic',
  'Bilinirlik': 'Awareness',
  'Etkileşim': 'Engagement',
  'Uygulama': 'App',
  'Dönüşüm': 'Conversions',
  'Elde Tutma': 'Retention',
  'Ürün veya hizmet satışı': 'Product or service sale',
  'Potansiyel müşteri formu': 'Potential customer form',
  'Web sitesi ziyaretçisi': 'Website visitor',
  'Marka görünürlüğü': 'Brand visibility',
  'Beğeni, yorum, paylaşım': 'Likes, comments, shares',
  'Uygulama indirme': 'App download',
  'Online satış ve dönüşüm': 'Online sales and conversion',
  'Form doldurma ve iletişim': 'Form fill and contact',
  'Marka bilinirliği': 'Brand awareness',
  'Tıklama optimizasyonu': 'Click optimization',
  'Dönüşüm optimizasyonu': 'Conversion optimization',
  'Gösterim optimizasyonu': 'Impression optimization',
  'Mevcut müşteriyi geri kazanma (Retention)': 'Win back existing customers (Retention)',
  'Hedef Kitle': 'Target Audience',
  'Min. Yaş': 'Min. Age',
  'Max. Yaş': 'Max. Age',
  'Cinsiyet': 'Gender',
  'Tümü': 'All',
  'Erkek': 'Male',
  'Kadın': 'Female',
  'Lokasyon': 'Location',
  'İlgi Alanları': 'Interests',
  'Moda, Teknoloji, Spor...': 'Fashion, Technology, Sports...',
  'Anahtar Kelimeler': 'Keywords',
  'dijital pazarlama ajansı\n"reklam yönetimi"\n[google ads danışmanlığı]': 'digital marketing agency\n"ad management"\n[google ads consulting]',
  "ChatGPT Ads şu anda geniş hedefleme (context hint) kullanır, ayrıntılı kitle/anahtar kelime ayarı yoktur — bütçe ve zamanlamayı belirleyip devam edin.": "ChatGPT Ads currently uses broad targeting (context hint) — there is no detailed audience/keyword setting, set the budget and schedule and continue.",
  'Bütçe & Zamanlama': 'Budget & Scheduling',
  'ChatGPT Ads yaşam boyu bütçe (lifetime budget) kullanır — "Toplam Bütçe" alanı esas alınır': 'ChatGPT Ads uses a lifetime budget — the "Total Budget" field is used',
  'Criteo yaşam boyu harcama limiti (spend limit) kullanır — "Toplam Bütçe" alanı esas alınır': 'Criteo uses a lifetime spend limit — the "Total Budget" field is used',
  'hesabınızın para birimi': 'your account currency',
  'Toplam boşsa günlük bütçe × 30 olarak hesaplanır.': 'If Total is empty, it is calculated as daily budget × 30.',
  "Yayına girmesi için Ayarlar'da bir Dataset ID kayıtlı olmalı.": 'A Dataset ID must be registered in Settings for it to go live.',
  'Günlük Bütçe (yaklaşık)': 'Daily Budget (approx.)',
  'Günlük Bütçe (₺)': 'Daily Budget (₺)',
  'Toplam Bütçe (esas alınır)': 'Total Budget (used)',
  'Toplam Bütçe (₺)': 'Total Budget (₺)',
  'Başlangıç Tarihi': 'Start Date',
  'Bitiş Tarihi': 'End Date',
  'Reklam İçeriği': 'Ad Content',
  'Başlık (en fazla 50 karakter)': 'Headline (max 50 characters)',
  'Başlık': 'Headline',
  'Yaz İndirimleri Başladı!': 'Summer Sale Has Started!',
  'Açıklama': 'Description',
  '(en fazla 100 karakter)': '(max 100 characters)',
  "Tüm ürünlerde %50'ye varan indirimler...": 'Up to 50% off on all products...',
  'Açıklama 2': 'Description 2',
  'Google Ads reklamlarında en az 2 açıklama zorunludur.': 'Google Ads requires at least 2 descriptions.',
  'Ücretsiz kargo ve kolay iade avantajlarıyla.': 'With free shipping and easy returns.',
  'Hedef URL': 'Target URL',
  'CTA Butonu': 'CTA Button',
  'Şimdi Al': 'Shop Now',
  'Daha Fazla Bilgi': 'Learn More',
  'Kaydol': 'Sign Up',
  'İletişime Geç': 'Contact Us',
  'İndir': 'Download',
  'Rezervasyon Yap': 'Book Now',
  'Görsel URL': 'Image URL',
  'Görsel URL (opsiyonel)': 'Image URL (optional)',
  'ChatGPT Ads chat-card reklamları görsel zorunlu tutar.': 'ChatGPT Ads chat-card ads require an image.',
  "Criteo creative'i görsel zorunlu tutar (indirilip base64 olarak gönderilir).": "Criteo creative requires an image (it is downloaded and sent as base64).",
  'Kampanya Özeti': 'Campaign Summary',
  'Günlük Bütçe': 'Daily Budget',
  'Toplam Bütçe': 'Total Budget',
  'Tarih': 'Date',
  'Yaş': 'Age',
  'Anahtar Kelime Sayısı': 'Number of Keywords',
  'URL': 'URL',
  'CTA': 'CTA',
  'Notlar': 'Notes',
  'Ek notlar...': 'Additional notes...',
  'Kampanya adı zorunludur.': 'Campaign name is required.',
  'Hedef URL http:// veya https:// ile başlamalı.': 'Target URL must start with http:// or https://.',
  'Bu taslağı silmek istediğinizden emin misiniz?': 'Are you sure you want to delete this draft?',
});

const API = '/api/v1';

const OBJECTIVES = {
  meta: [
    { id:'OUTCOME_SALES',      label:'Satış',        icon:'🛒', desc:'Ürün veya hizmet satışı' },
    { id:'OUTCOME_LEADS',      label:'Lead',         icon:'📋', desc:'Potansiyel müşteri formu' },
    { id:'OUTCOME_TRAFFIC',    label:'Trafik',       icon:'🔗', desc:'Web sitesi ziyaretçisi' },
    { id:'OUTCOME_AWARENESS',  label:'Bilinirlik',   icon:'📢', desc:'Marka görünürlüğü' },
    { id:'OUTCOME_ENGAGEMENT', label:'Etkileşim',    icon:'❤️', desc:'Beğeni, yorum, paylaşım' },
    { id:'OUTCOME_APP_PROMOTION', label:'Uygulama', icon:'📱', desc:'Uygulama indirme' },
  ],
  google: [
    { id:'SALES',       label:'Satış',      icon:'🛒', desc:'Online satış ve dönüşüm' },
    { id:'LEADS',       label:'Lead',       icon:'📋', desc:'Form doldurma ve iletişim' },
    { id:'TRAFFIC',     label:'Trafik',     icon:'🔗', desc:'Web sitesi ziyaretçisi' },
    { id:'AWARENESS',   label:'Bilinirlik', icon:'📢', desc:'Marka bilinirliği' },
    { id:'APP',         label:'Uygulama',   icon:'📱', desc:'Uygulama indirme' },
  ],
  chatgpt: [
    { id:'clicks',      label:'Trafik',     icon:'🔗', desc:'Tıklama optimizasyonu' },
    { id:'conversions', label:'Dönüşüm',    icon:'🛒', desc:'Dönüşüm optimizasyonu' },
    { id:'impressions', label:'Bilinirlik', icon:'📢', desc:'Gösterim optimizasyonu' },
  ],
  criteo: [
    { id:'clicks',      label:'Trafik',      icon:'🔗', desc:'Tıklama optimizasyonu' },
    { id:'conversions', label:'Dönüşüm',     icon:'🛒', desc:'Dönüşüm optimizasyonu' },
    { id:'displays',    label:'Bilinirlik',  icon:'📢', desc:'Gösterim optimizasyonu' },
    { id:'retention',   label:'Elde Tutma',  icon:'♻️', desc:'Mevcut müşteriyi geri kazanma (Retention)' },
  ],
};

const ALL_OBJECTIVES = ([] as {id:string;label:string}[]).concat(
  OBJECTIVES.meta, OBJECTIVES.google, OBJECTIVES.chatgpt, OBJECTIVES.criteo,
);
function objectiveLabel(id:string, t:(s:string)=>string):string {
  if(!id) return '—';
  const found = ALL_OBJECTIVES.find(o=>o.id===id);
  return found ? t(found.label) : id;
}

const PLATFORM_INFO: Record<string,{label:string;icon:string;bg:string;color:string;activeVal:string;endpoint:string}> = {
  meta:    { label:'Meta Ads',    icon:'/meta-icon.png',       bg:'var(--py-purple-tint)', color:T.purpleText, activeVal:'ACTIVE',  endpoint:'meta' },
  google:  { label:'Google Ads',  icon:'/google-ads-icon.png', bg:'var(--py-amber-tint-alt)', color:T.accentDeep, activeVal:'ENABLED', endpoint:'google' },
  chatgpt: { label:'ChatGPT Ads', icon:'/chatgpt-icon.png',    bg:'#EAF7F0', color:'#10A37F',  activeVal:'active',  endpoint:'chatgpt' },
  criteo:  { label:'Criteo',      icon:'/criteo-icon.png',     bg:'#FFF0E6', color:'#FE5000',  activeVal:'active',  endpoint:'criteo' },
};

const STATUS_MAP: Record<string,{label:string;bg:string;fg:string}> = {
  draft:     { label:'Taslak',        bg:'var(--py-track-bg)', fg:'var(--py-text-mid-alt)' },
  review:    { label:'Onay Bekliyor', bg:'var(--py-amber-tint-alt)', fg:T.amberText },
  approved:  { label:'Onaylandı',     bg:'var(--py-green-tint)', fg:T.greenText },
  rejected:  { label:'Reddedildi',    bg:'var(--py-red-tint)', fg:T.redText },
  published: { label:'Yayında',       bg:'var(--py-blue-tint)', fg:T.blueText },
};

const inputStyle:React.CSSProperties={width:'100%',padding:'10px 12px',border:`1px solid ${T.borderMid}`,borderRadius:10,fontSize:13,color:T.text,outline:'none',fontFamily:'inherit',background:T.surface,boxSizing:'border-box' as const};

// ── Input ─────────────────────────────────────────────────
function Inp({label,value,onChange,type='text',placeholder='',required=false}:{label:string;value:string;onChange:(v:string)=>void;type?:string;placeholder?:string;required?:boolean}){
  return(
    <div style={{display:'flex',flexDirection:'column',gap:6}}>
      <label style={{fontSize:11,fontWeight:700,color:'var(--py-text-mid-alt)'}}>{label}{required&&<span style={{color:T.redText}}> *</span>}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={inputStyle}/>
    </div>
  );
}

// ── Step Indicator ────────────────────────────────────────
function StepBar({step,total}:{step:number;total:number}){
  const { t } = useLang();
  const labels = ['Platform','Hedef','Kitle & Bütçe','Reklam','Özet'];
  return(
    <div style={{display:'flex',alignItems:'center',gap:0,marginBottom:24}}>
      {labels.map((l,i)=>{
        const done=i<step, active=i===step;
        return(
          <React.Fragment key={i}>
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:5}}>
              <div style={{width:30,height:30,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,
                background:done?T.accent:active?'var(--py-ink)':'var(--py-track-bg)',
                color:done||active?'#fff':T.textDim,transition:'all 0.2s'}}>
                {done?'✓':i+1}
              </div>
              <span style={{fontSize:10,fontWeight:600,color:active?T.text:T.textDim,whiteSpace:'nowrap' as const}}>{t(l)}</span>
            </div>
            {i<total-1&&<div style={{flex:1,height:1,background:done?T.accent:T.border,margin:'0 4px',marginBottom:18,transition:'background 0.3s'}}/>}
          </React.Fragment>
        );
      })}
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────
function apiErrorText(e:any):string{
  const d = e?.response?.data;
  if(typeof d==='string') return d;
  if(d?.detail) return typeof d.detail==='string'?d.detail:JSON.stringify(d.detail).slice(0,200);
  if(d?.error) return typeof d.error==='string'?d.error:JSON.stringify(d.error).slice(0,200);
  return e?.message || 'Bilinmeyen bir hata oluştu';
}

export default function CampaignBuilderTab({config, clientId}:{config:any; clientId?:number}){
  const { t, lang } = useLang();
  const [view, setView] = useState<'list'|'wizard'>('list');
  const [step, setStep] = useState(0);
  const [drafts, setDrafts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState<number|null>(null);
  const [publishing, setPublishing] = useState(false);
  const [publishResult, setPublishResult] = useState<any>(null);
  const [publishPlatform, setPublishPlatform] = useState<'meta'|'google'|'chatgpt'|'criteo'>('meta');
  const [errorMsg, setErrorMsg] = useState('');
  const [togglingId, setTogglingId] = useState<number|null>(null);

  const publishDraft = async (id: number, platformId: 'meta'|'google'|'chatgpt'|'criteo') => {
    setPublishing(true);
    setPublishPlatform(platformId);
    try {
      const r = await axios.post(`${API}/campaigns/${PLATFORM_INFO[platformId].endpoint}/publish/${id}`);
      setPublishResult(r.data);
      loadDrafts();
    } catch(e: any) {
      setPublishResult({success: false, error: apiErrorText(e)});
    }
    setPublishing(false);
  };

  const toggleCampaignStatus = async (d:any) => {
    const info = PLATFORM_INFO[d.platform] || PLATFORM_INFO.meta;
    const pausedVal = (d.platform==='chatgpt'||d.platform==='criteo') ? 'paused' : 'PAUSED';
    const liveStatus = d.meta_data?.live_status || pausedVal;
    const goingActive = liveStatus !== info.activeVal;
    const confirmMsg = lang==='en'
      ? `You are about to activate "${d.name}" — it will start spending real budget. Do you confirm?`
      : `"${d.name}" kampanyasını aktif etmek üzeresiniz — gerçek bütçe harcamaya başlayacak. Onaylıyor musunuz?`;
    if(goingActive && !window.confirm(confirmMsg)) return;
    setTogglingId(d.id);
    setErrorMsg('');
    try {
      const newStatus = goingActive ? info.activeVal : pausedVal;
      const r = await axios.post(`${API}/campaigns/${info.endpoint}/status/${d.id}`, {status:newStatus});
      if(!r.data.success) setErrorMsg(apiErrorText({response:{data:r.data}}));
      loadDrafts();
    } catch(e:any) {
      setErrorMsg(apiErrorText(e));
    }
    setTogglingId(null);
  };

  // Wizard state
  const [platform, setPlatform] = useState<'meta'|'google'|'chatgpt'|'criteo'>('meta');
  const [name, setName] = useState('');
  const [objective, setObjective] = useState('');
  const [budgetDaily, setBudgetDaily] = useState('');
  const [budgetTotal, setBudgetTotal] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [targeting, setTargeting] = useState({age_min:'18',age_max:'65',gender:'all',locations:'Türkiye',interests:'',keywords:''});
  const [creative, setCreative] = useState({headline:'',description:'',description2:'',cta:'Şimdi Al',url:'',image_url:''});
  const [notes, setNotes] = useState('');

  const loadDrafts = () => {
    axios.get(`${API}/campaigns/drafts`)
      .then(r=>{ setDrafts(r.data); setLoading(false); })
      .catch(e=>{ setErrorMsg(apiErrorText(e)); setLoading(false); });
  };

  useEffect(()=>{ loadDrafts(); },[]);

  useEffect(()=>{
    const prefill = localStorage.getItem('poyais_prefill_platform');
    if(prefill && PLATFORM_INFO[prefill]){
      localStorage.removeItem('poyais_prefill_platform');
      resetWizard();
      setPlatform(prefill as 'meta'|'google'|'chatgpt');
      setView('wizard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const resetWizard = () => {
    setStep(0); setEditId(null); setName(''); setObjective(''); setPlatform('meta');
    setBudgetDaily(''); setBudgetTotal(''); setStartDate(''); setEndDate('');
    setTargeting({age_min:'18',age_max:'65',gender:'all',locations:'Türkiye',interests:'',keywords:''});
    setCreative({headline:'',description:'',description2:'',cta:'Şimdi Al',url:'',image_url:''});
    setNotes('');
  };

  const saveDraft = async (status='draft') => {
    if(!name.trim()){ setErrorMsg(t('Kampanya adı zorunludur.')); return; }
    if(!creative.url.trim() || !/^https?:\/\//i.test(creative.url.trim())){ setErrorMsg(t('Hedef URL http:// veya https:// ile başlamalı.')); return; }
    setSaving(true);
    setErrorMsg('');
    const body = {
      platform, name, objective, status,
      client_id: clientId || 1,
      budget_daily: parseFloat(budgetDaily)||0,
      budget_total: parseFloat(budgetTotal)||0,
      start_date: startDate, end_date: endDate,
      targeting, creative, notes,
      meta_data: {}
    };
    try {
      if(editId) await axios.put(`${API}/campaigns/drafts/${editId}`, body);
      else await axios.post(`${API}/campaigns/drafts`, body);
      loadDrafts();
      setView('list');
      resetWizard();
    } catch(e:any) {
      setErrorMsg(apiErrorText(e));
    }
    setSaving(false);
  };

  const updateStatus = async (id:number, status:string) => {
    setErrorMsg('');
    try {
      await axios.patch(`${API}/campaigns/drafts/${id}/status`, {status});
      loadDrafts();
    } catch(e:any) {
      setErrorMsg(apiErrorText(e));
    }
  };

  const deleteDraft = async (id:number) => {
    if(!window.confirm(t('Bu taslağı silmek istediğinizden emin misiniz?'))) return;
    setErrorMsg('');
    try {
      await axios.delete(`${API}/campaigns/drafts/${id}`);
      loadDrafts();
    } catch(e:any) {
      setErrorMsg(apiErrorText(e));
    }
  };

  const editDraft = (d:any) => {
    setErrorMsg('');
    setEditId(d.id); setPlatform(d.platform); setName(d.name); setObjective(d.objective||'');
    setBudgetDaily(String(d.budget_daily||'')); setBudgetTotal(String(d.budget_total||''));
    setStartDate(d.start_date||''); setEndDate(d.end_date||'');
    setTargeting(d.targeting||{age_min:'18',age_max:'65',gender:'all',locations:'Türkiye',interests:'',keywords:''});
    setCreative({headline:'',description:'',description2:'',cta:'Şimdi Al',url:'',image_url:'',...(d.creative||{})});
    setNotes(d.notes||''); setStep(0); setView('wizard');
  };

  // ── LIST VIEW ──────────────────────────────────────────
  if(view==='list') return(
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',gap:14,flexWrap:'wrap' as const}}>
        <button onClick={()=>{resetWizard();setView('wizard');}} style={{display:'inline-flex',alignItems:'center',gap:8,background:T.accent,color:'#fff',border:'none',borderRadius:11,padding:'9px 16px',fontFamily:'inherit',fontSize:13,fontWeight:700,cursor:'pointer'}}>
          {t('Yeni Kampanya')}
        </button>
      </div>

      {errorMsg&&(
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,background:'var(--py-red-tint)',border:`1px solid ${alpha(T.red, 25)}`,borderRadius:11,padding:'11px 16px'}}>
          <span style={{fontSize:12.5,color:T.redText,fontWeight:600}}>{t(errorMsg)}</span>
          <button onClick={()=>setErrorMsg('')} style={{background:'none',border:'none',color:T.redText,fontSize:14,fontWeight:800,cursor:'pointer',lineHeight:1}}>✕</button>
        </div>
      )}

      {/* Publish Result Modal */}
      {publishResult&&(
        <div style={{position:'fixed',inset:0,background:'rgba(20,22,43,0.45)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
          <div style={{background:T.surface,borderRadius:16,padding:'26px 28px',maxWidth:440,width:'100%',boxShadow:'0 20px 60px rgba(20,22,43,.25)'}}>
            <div style={{fontSize:15,fontWeight:800,color:T.text,marginBottom:14,textAlign:'center' as const}}>
              {publishResult.success
                ? (lang==='en' ? `Sent to ${PLATFORM_INFO[publishPlatform].label}` : `${PLATFORM_INFO[publishPlatform].label}'e Gönderildi`)
                : t('Hata Oluştu')}
            </div>
            {publishResult.success&&(
              <div style={{display:'flex',flexDirection:'column' as const,gap:6,marginBottom:16}}>
                {(publishPlatform==='meta'?[
                  {l:'Campaign ID', v:publishResult.campaign_id},
                  {l:'AdSet ID',    v:publishResult.adset_id},
                ]:publishPlatform==='chatgpt'?[
                  {l:'Campaign ID', v:publishResult.campaign_id},
                  {l:'Ad Group ID', v:publishResult.ad_group_id},
                  {l:'Ad ID',       v:publishResult.ad_id},
                ]:publishPlatform==='criteo'?[
                  {l:'Campaign ID', v:publishResult.campaign_id},
                  {l:'Ad Set ID',   v:publishResult.ad_set_id},
                  {l:'Creative ID', v:publishResult.creative_id},
                  {l:'Ad ID',       v:publishResult.ad_id},
                ]:[
                  {l:'Campaign ID', v:publishResult.campaign_id},
                  {l:'Ad Group ID', v:publishResult.ad_group_id},
                ]).map((r,i)=>(
                  <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'9px 12px',background:'var(--py-subtle-bg)',border:`1px solid ${T.tableDivider}`,borderRadius:9}}>
                    <span style={{fontSize:11,color:'var(--py-text-mid-alt)'}}>{r.l}</span>
                    <span style={{fontSize:11,fontWeight:700,color:T.text,fontFamily:MONO}}>{r.v}</span>
                  </div>
                ))}
                <div style={{background:'var(--py-amber-tint-alt)',border:`1px solid ${alpha(T.amber, 25)}`,borderRadius:9,padding:'10px 12px',marginTop:4}}>
                  <div style={{fontSize:11.5,color:T.amberDeepText}}>
                    {(() => {
                      const paused = t('Kampanya PAUSED olarak oluşturuldu.');
                      if (publishPlatform === 'google') {
                        const kw = Number(publishResult.keywords_added) || 0;
                        return kw > 0
                          ? `${paused} ${kw} ${t('anahtar kelime eklendi.')} ${t("Google Ads'ten kontrol edip aktif edebilirsiniz.")}`
                          : `${paused} ${t("Anahtar kelime girilmedi. Yayına almadan önce Google Ads'ten eklemeniz gerekir.")}`;
                      }
                      if (publishPlatform === 'meta')
                        return t("Kampanya PAUSED olarak oluşturuldu. Meta Ads Manager'dan creative ekleyip aktif edebilirsiniz.");
                      if (publishPlatform === 'chatgpt')
                        return t("Kampanya paused olarak oluşturuldu. OpenAI Ads Manager'dan kontrol edip aktif edebilirsiniz.");
                      if (publishPlatform === 'criteo')
                        return `${paused} ${t("Criteo Management Center'dan kontrol edip aktif edebilirsiniz.")}`;
                      return publishResult.message || paused;
                    })()}
                  </div>
                </div>
              </div>
            )}
            {!publishResult.success&&(
              <div style={{fontSize:12,color:T.redText,background:'var(--py-red-tint)',padding:'10px 12px',borderRadius:9,marginBottom:16}}>
                {JSON.stringify(publishResult.error||publishResult).slice(0,200)}
              </div>
            )}
            <button onClick={()=>setPublishResult(null)} style={{width:'100%',padding:'9px 16px',background:T.accent,color:'#fff',border:'none',borderRadius:11,fontSize:13,fontWeight:700,cursor:'pointer'}}>
              {t('Tamam')}
            </button>
          </div>
        </div>
      )}

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))',gap:10}}>
        {[
          {label:'Toplam',    value:drafts.length,                                        color:T.text},
          {label:'Taslak',    value:drafts.filter(d=>d.status==='draft').length,           color:'var(--py-text-mid-alt)'},
          {label:'Onay Bekliyor', value:drafts.filter(d=>d.status==='review').length,     color:T.amberText},
          {label:'Yayında',   value:drafts.filter(d=>d.status==='published').length,       color:T.blueText},
        ].map((s,i)=>(
          <div key={i} style={{border:`1px solid ${T.border}`,borderRadius:14,background:T.surface,padding:'16px 18px'}}>
            <div style={{fontSize:11,fontWeight:600,color:'var(--py-text-mid-alt)',marginBottom:6}}>{t(s.label)}</div>
            <div style={{fontSize:22,fontWeight:800,fontFamily:MONO,color:s.color}}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Draft List */}
      {loading?(
        <div style={{border:`1px solid ${T.border}`,borderRadius:16,background:T.surface,padding:'40px 20px'}}>
          <PoyaisSpinner/>
        </div>
      ):drafts.length===0?(
        <div style={{border:`1px solid ${T.border}`,borderRadius:16,background:T.surface,padding:'60px 20px',textAlign:'center' as const}}>
          <div style={{fontSize:13.5,fontWeight:700,marginBottom:6}}>{t('Henüz kampanya taslağı yok')}</div>
          <div style={{fontSize:12.5,color:T.textDim,marginBottom:20}}>{t('Yeni kampanya oluşturmak için butona tıklayın.')}</div>
          <button onClick={()=>{resetWizard();setView('wizard');}} style={{background:T.accent,color:'#fff',border:'none',borderRadius:11,padding:'9px 16px',fontFamily:'inherit',fontSize:13,fontWeight:700,cursor:'pointer'}}>
            {t('Yeni Kampanya Oluştur')}
          </button>
        </div>
      ):(
        <div style={{display:'flex',flexDirection:'column' as const,gap:10}}>
          {drafts.map((d:any)=>{
            const st = STATUS_MAP[d.status]||STATUS_MAP.draft;
            return(
              <div key={d.id} style={{border:`1px solid ${T.border}`,borderRadius:14,background:T.surface,padding:'14px 18px',display:'flex',alignItems:'center',gap:14,flexWrap:'wrap' as const}}>
                <span style={{width:36,height:36,borderRadius:10,background:PLATFORM_INFO[d.platform]?.bg||'var(--py-track-bg)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,padding:8,boxSizing:'border-box' as const}}>
                  <img src={PLATFORM_INFO[d.platform]?.icon} alt={PLATFORM_INFO[d.platform]?.label} style={{width:'100%',height:'100%',objectFit:'contain' as const}}/>
                </span>
                <div style={{flex:1,minWidth:180}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap' as const}}>
                    <span style={{fontSize:13.5,fontWeight:800}}>{d.name}</span>
                    <span style={{fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999,background:st.bg,color:st.fg}}>{t(st.label)}</span>
                    {d.status==='published'&&(()=>{
                      const activeVal = PLATFORM_INFO[d.platform]?.activeVal;
                      const pausedVal = (d.platform==='chatgpt'||d.platform==='criteo') ? 'paused' : 'PAUSED';
                      const live = d.meta_data?.live_status || pausedVal;
                      const isActive = live===activeVal;
                      return(
                        <span style={{display:'inline-flex',alignItems:'center',gap:5,fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999,background:isActive?'var(--py-green-tint)':'var(--py-track-bg)',color:isActive?T.greenText:T.textDim}}>
                          <span style={{width:6,height:6,borderRadius:'50%',background:isActive?T.greenText:T.textDim}}/>
                          {isActive?t('Yayında Aktif'):t('Durduruldu')}
                        </span>
                      );
                    })()}
                  </div>
                  <div style={{fontSize:11.5,color:'var(--py-text-mid-alt)'}}>
                    {PLATFORM_INFO[d.platform]?.label} · {objectiveLabel(d.objective, t)}
                    {d.budget_daily>0?` · ₺${d.budget_daily}/${t('gün')}`:''}
                    {d.start_date?` · ${d.start_date}`:''}
                  </div>
                </div>
                <div style={{display:'flex',gap:6,flexShrink:0,flexWrap:'wrap' as const}}>
                  {d.status==='draft'&&(
                    <button onClick={()=>updateStatus(d.id,'review')} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${alpha(T.amber, 25)}`,background:'var(--py-amber-tint-alt)',color:T.amberDeepText,fontSize:12,fontWeight:700,cursor:'pointer'}}>
                      {t('Onaya Gönder')}
                    </button>
                  )}
                  {d.status==='review'&&(
                    <>
                      <button onClick={()=>updateStatus(d.id,'approved')} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${alpha(T.green, 25)}`,background:'var(--py-green-tint)',color:T.greenText,fontSize:12,fontWeight:700,cursor:'pointer'}}>
                        {t('Onayla')}
                      </button>
                      <button onClick={()=>updateStatus(d.id,'rejected')} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${alpha(T.red, 25)}`,background:'var(--py-red-tint)',color:T.redText,fontSize:12,fontWeight:700,cursor:'pointer'}}>
                        {t('Reddet')}
                      </button>
                    </>
                  )}
                  {d.status==='approved'&&d.platform==='meta'&&(
                    <button disabled={publishing} onClick={()=>publishDraft(d.id,'meta')} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${alpha(T.blue, 25)}`,background:'var(--py-blue-tint)',color:T.blueText,fontSize:12,fontWeight:700,cursor:publishing?'wait':'pointer'}}>
                      {publishing?t('Gönderiliyor…'):t("Meta'ya Yayınla")}
                    </button>
                  )}
                  {d.status==='approved'&&d.platform==='google'&&(
                    <button disabled={publishing} onClick={()=>publishDraft(d.id,'google')} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${alpha(T.amber, 25)}`,background:'var(--py-amber-tint-alt)',color:T.accentDeep,fontSize:12,fontWeight:700,cursor:publishing?'wait':'pointer'}}>
                      {publishing?t('Gönderiliyor…'):t("Google Ads'e Yayınla")}
                    </button>
                  )}
                  {d.status==='approved'&&d.platform==='chatgpt'&&(
                    <button disabled={publishing} onClick={()=>publishDraft(d.id,'chatgpt')} style={{padding:'7px 13px',borderRadius:9,border:'1px solid #B8E8D4',background:'#EAF7F0',color:'#0E7C5C',fontSize:12,fontWeight:700,cursor:publishing?'wait':'pointer'}}>
                      {publishing?t('Gönderiliyor…'):t("ChatGPT Ads'e Yayınla")}
                    </button>
                  )}
                  {d.status==='approved'&&d.platform==='criteo'&&(
                    <button disabled={publishing} onClick={()=>publishDraft(d.id,'criteo')} style={{padding:'7px 13px',borderRadius:9,border:'1px solid #FFD4B8',background:'#FFF0E6',color:'#C94100',fontSize:12,fontWeight:700,cursor:publishing?'wait':'pointer'}}>
                      {publishing?t('Gönderiliyor…'):t("Criteo'ya Yayınla")}
                    </button>
                  )}
                  {d.status==='published'&&(()=>{
                    const activeVal = PLATFORM_INFO[d.platform]?.activeVal;
                    const pausedVal = (d.platform==='chatgpt'||d.platform==='criteo') ? 'paused' : 'PAUSED';
                    const live = d.meta_data?.live_status || pausedVal;
                    const isActive = live===activeVal;
                    const busy = togglingId===d.id;
                    const platformUrl = d.platform==='meta'
                      ? (d.meta_data?.campaign_id ? `https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=${d.meta_data.account_id||''}&selected_campaign_ids=${d.meta_data.campaign_id}` : '')
                      : d.platform==='google'
                      ? (d.meta_data?.campaign_resource ? `https://ads.google.com/aw/campaigns?campaignId=${d.meta_data.campaign_resource.split('/').pop()}` : '')
                      : d.platform==='chatgpt'
                      ? (d.meta_data?.campaign_id ? 'https://ads.openai.com/' : '')
                      : (d.meta_data?.campaign_id ? 'https://www.criteo.com/login/' : '');
                    return(
                      <>
                        <button disabled={busy} onClick={()=>toggleCampaignStatus(d)}
                          style={{padding:'7px 13px',borderRadius:9,border:isActive?`1px solid ${alpha(T.red, 25)}`:`1px solid ${alpha(T.green, 25)}`,background:isActive?'var(--py-red-tint)':'var(--py-green-tint)',color:isActive?T.redText:T.greenText,fontSize:12,fontWeight:700,cursor:busy?'wait':'pointer'}}>
                          {busy?t('İşleniyor…'):isActive?t('Durdur'):t('Aktif Et')}
                        </button>
                        {platformUrl&&(
                          <a href={platformUrl} target="_blank" rel="noreferrer" style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${T.borderMid}`,background:T.surface,color:T.textMid,fontSize:12,fontWeight:700,textDecoration:'none',display:'inline-flex',alignItems:'center'}}>
                            {t('Platformda Aç')}
                          </a>
                        )}
                      </>
                    );
                  })()}
                  <button onClick={()=>editDraft(d)} style={{padding:'7px 13px',borderRadius:9,border:`1px solid ${T.borderMid}`,background:T.surface,color:T.textMid,fontSize:12,fontWeight:700,cursor:'pointer'}}>
                    {t('Düzenle')}
                  </button>
                  <button onClick={()=>deleteDraft(d.id)} style={{padding:'7px 10px',borderRadius:9,border:`1px solid ${alpha(T.red, 25)}`,background:'var(--py-red-tint)',color:T.redText,fontSize:12,fontWeight:700,cursor:'pointer'}}>
                    ✕
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  // ── WIZARD VIEW ────────────────────────────────────────
  const objs = OBJECTIVES[platform] || [];
  const canNext = [
    !!platform,
    !!objective,
    (platform==='chatgpt'||platform==='criteo') ? (!!budgetDaily || !!budgetTotal) : !!budgetDaily,
    !!creative.headline && !!creative.url && (platform!=='google' || !!creative.description2) && ((platform!=='chatgpt'&&platform!=='criteo') || !!creative.image_url),
    true,
  ][step];

  return(
    <div style={{display:'flex',flexDirection:'column' as const,gap:0}}>
      {/* Wizard Header */}
      <div style={{border:`1px solid ${T.border}`,borderRadius:16,background:T.surface,padding:'20px 22px',marginBottom:16}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
          <div style={{fontSize:14,fontWeight:800}}>
            {editId?t('Kampanya Düzenle'):t('Yeni Kampanya Oluştur')}
          </div>
          <button onClick={()=>{setView('list');resetWizard();}} style={{background:'none',border:'none',cursor:'pointer',color:T.textMidAlt,fontSize:12.5,fontWeight:700}}>
            ← {t('Havuza Dön')}
          </button>
        </div>
        <StepBar step={step} total={5}/>
      </div>

      {errorMsg&&(
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,background:'var(--py-red-tint)',border:`1px solid ${alpha(T.red, 25)}`,borderRadius:11,padding:'11px 16px',marginBottom:16}}>
          <span style={{fontSize:12.5,color:T.redText,fontWeight:600}}>{t(errorMsg)}</span>
          <button onClick={()=>setErrorMsg('')} style={{background:'none',border:'none',color:T.redText,fontSize:14,fontWeight:800,cursor:'pointer',lineHeight:1}}>✕</button>
        </div>
      )}

      {/* Step Content */}
      <div style={{border:`1px solid ${T.border}`,borderRadius:16,background:T.surface,padding:24}}>

        {/* Adım 0: Platform */}
        {step===0&&(
          <div>
            <div style={{fontSize:14,fontWeight:800,marginBottom:6}}>{t('Platform Seç')}</div>
            <div style={{fontSize:12.5,color:T.textMidAlt,marginBottom:20}}>{t('Kampanyanızı hangi platformda yayınlamak istiyorsunuz?')}</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:14,marginBottom:20}}>
              {[
                {id:'meta'  as const, label:'Meta Ads',    icon:'/meta-icon.png',       desc:'Facebook & Instagram reklamları', color:T.purpleText, bg:'var(--py-purple-tint)', soon:false, disconnected:false},
                {id:'google'as const, label:'Google Ads',  icon:'/google-ads-icon.png', desc:'Arama reklamları',                color:T.accentDeep, bg:'var(--py-amber-tint-alt)', soon:false, disconnected:false},
                {id:'chatgpt'as const,label:'ChatGPT Ads', icon:'/chatgpt-icon.png',    desc:'ChatGPT sohbet içi reklamlar',     color:'#10A37F', bg:'#EAF7F0', soon:false, disconnected:!(config?.platforms as any)?.chatgpt_ads?.accountName},
                {id:'criteo'as const, label:'Criteo',      icon:'/criteo-icon.png',     desc:'Dinamik yeniden pazarlama reklamları', color:'#FE5000', bg:'#FFF0E6', soon:false, disconnected:!(config?.platforms as any)?.criteo?.advertiserName},
              ].map(p=>(
                <div key={p.id} onClick={()=>!p.soon&&!p.disconnected&&setPlatform(p.id)}
                  style={{border:`1px solid ${platform===p.id?p.color:T.border}`,borderRadius:14,padding:20,
                    cursor:(p.soon||p.disconnected)?'not-allowed':'pointer',position:'relative' as const,
                    background:(p.soon||p.disconnected)?T.subtleBg:platform===p.id?alpha(p.color, 6):T.surface,
                    opacity:(p.soon||p.disconnected)?0.6:1,transition:'border-color 0.15s'}}>
                  {p.soon&&(
                    <span style={{position:'absolute' as const,top:14,right:14,fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999,background:'var(--py-amber-tint-alt)',color:T.amberText}}>{t('YAKINDA')}</span>
                  )}
                  {p.disconnected&&(
                    <span style={{position:'absolute' as const,top:14,right:14,fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999,background:'var(--py-track-bg)',color:T.textMidAlt}}>{t('BAĞLI DEĞİL')}</span>
                  )}
                  <span style={{width:36,height:36,borderRadius:10,background:p.bg,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:12,padding:8,boxSizing:'border-box' as const}}>
                    <img src={p.icon} alt={p.label} style={{width:'100%',height:'100%',objectFit:'contain' as const}}/>
                  </span>
                  <div style={{fontSize:13.5,fontWeight:800,marginBottom:4}}>{p.label}</div>
                  <div style={{fontSize:12,color:T.textMidAlt}}>{t(p.desc)}</div>
                  {platform===p.id&&!p.soon&&<div style={{marginTop:10,fontSize:11,fontWeight:700,color:p.color}}>{t('✓ Seçildi')}</div>}
                </div>
              ))}
            </div>
            <Inp label={t('Kampanya Adı')} value={name} onChange={setName} placeholder={t('Örn: Yaz Koleksiyonu 2026')} required/>
          </div>
        )}

        {/* Adım 1: Hedef */}
        {step===1&&(
          <div>
            <div style={{fontSize:14,fontWeight:800,marginBottom:6}}>{t('Kampanya Hedefi')}</div>
            <div style={{fontSize:12.5,color:T.textMidAlt,marginBottom:20}}>{t('Bu kampanya ile ne elde etmek istiyorsunuz?')}</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))',gap:10}}>
              {objs.map(o=>(
                <div key={o.id} onClick={()=>setObjective(o.id)}
                  style={{border:`1px solid ${objective===o.id?T.accent:T.border}`,borderRadius:12,padding:14,cursor:'pointer',
                    background:objective===o.id?'var(--py-amber-tint)':T.surface,transition:'border-color 0.15s',textAlign:'center' as const}}>
                  <div style={{fontSize:22,marginBottom:6}}>{o.icon}</div>
                  <div style={{fontSize:12,fontWeight:700,marginBottom:3}}>{t(o.label)}</div>
                  <div style={{fontSize:10.5,color:T.textDim}}>{t(o.desc)}</div>
                  {objective===o.id&&<div style={{marginTop:6,fontSize:10,fontWeight:700,color:T.accentDeep}}>{t('✓ Seçildi')}</div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Adım 2: Kitle & Bütçe */}
        {step===2&&(
          <div style={{display:'flex',flexDirection:'column' as const,gap:20}}>
            {platform==='meta'?(
              <div>
                <div style={{fontSize:14,fontWeight:800,marginBottom:12}}>{t('Hedef Kitle')}</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <Inp label={t('Min. Yaş')} value={targeting.age_min} onChange={v=>setTargeting({...targeting,age_min:v})} type="number"/>
                  <Inp label={t('Max. Yaş')} value={targeting.age_max} onChange={v=>setTargeting({...targeting,age_max:v})} type="number"/>
                  <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
                    <label style={{fontSize:11,fontWeight:700,color:T.textMidAlt}}>{t('Cinsiyet')}</label>
                    <select value={targeting.gender} onChange={e=>setTargeting({...targeting,gender:e.target.value})} style={inputStyle}>
                      <option value="all">{t('Tümü')}</option>
                      <option value="male">{t('Erkek')}</option>
                      <option value="female">{t('Kadın')}</option>
                    </select>
                  </div>
                  <Inp label={t('Lokasyon')} value={targeting.locations} onChange={v=>setTargeting({...targeting,locations:v})} placeholder="Türkiye"/>
                </div>
                <div style={{marginTop:12}}>
                  <Inp label={t('İlgi Alanları')} value={targeting.interests} onChange={v=>setTargeting({...targeting,interests:v})} placeholder={t('Moda, Teknoloji, Spor...')}/>
                </div>
              </div>
            ):platform==='google'?(
              <div>
                <div style={{fontSize:14,fontWeight:800,marginBottom:6}}>{t('Anahtar Kelimeler')}</div>
                <div style={{fontSize:11.5,color:T.textDim,marginBottom:10,lineHeight:1.5}}>
                  {lang==='en'?(
                    <>Write one keyword per line. Use <b>[square brackets]</b> for exact match, <b>"quotes"</b> for phrase match — otherwise broad match applies.</>
                  ):(
                    <>Her satıra bir anahtar kelime yazın. Tam eşleşme için <b>[köşeli parantez]</b>, ifade eşleşmesi için <b>"tırnak"</b> kullanın — aksi halde geniş eşleşme uygulanır.</>
                  )}
                </div>
                <textarea value={targeting.keywords||''} onChange={e=>setTargeting({...targeting,keywords:e.target.value})}
                  rows={7} placeholder={t('dijital pazarlama ajansı\n"reklam yönetimi"\n[google ads danışmanlığı]')}
                  style={{...inputStyle,resize:'vertical' as const}}/>
              </div>
            ):(
              <div style={{background:T.subtleBg,border:`1px solid ${T.tableDivider}`,borderRadius:10,padding:'12px 14px',fontSize:12,color:T.textMidAlt,lineHeight:1.5}}>
                {t('ChatGPT Ads şu anda geniş hedefleme (context hint) kullanır, ayrıntılı kitle/anahtar kelime ayarı yoktur — bütçe ve zamanlamayı belirleyip devam edin.')}
              </div>
            )}
            <div>
              <div style={{fontSize:14,fontWeight:800,marginBottom:12}}>{t('Bütçe & Zamanlama')}</div>
              {platform==='chatgpt'&&(
                <div style={{fontSize:11,color:T.textDim,marginBottom:10}}>
                  {t('ChatGPT Ads yaşam boyu bütçe (lifetime budget) kullanır — "Toplam Bütçe" alanı esas alınır')}{(config?.platforms as any)?.chatgpt_ads?.currency?`, ${t('hesabınızın para birimi')}: ${(config?.platforms as any).chatgpt_ads.currency}`:''}. {t('Toplam boşsa günlük bütçe × 30 olarak hesaplanır.')}
                </div>
              )}
              {platform==='criteo'&&(
                <div style={{fontSize:11,color:T.textDim,marginBottom:10}}>
                  {t('Criteo yaşam boyu harcama limiti (spend limit) kullanır — "Toplam Bütçe" alanı esas alınır')}{(config?.platforms as any)?.criteo?.currency?`, ${t('hesabınızın para birimi')}: ${(config?.platforms as any).criteo.currency}`:''}. {t('Toplam boşsa günlük bütçe × 30 olarak hesaplanır.')} {t("Yayına girmesi için Ayarlar'da bir Dataset ID kayıtlı olmalı.")}
                </div>
              )}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <Inp label={(platform==='chatgpt'||platform==='criteo')?t('Günlük Bütçe (yaklaşık)'):t('Günlük Bütçe (₺)')} value={budgetDaily} onChange={setBudgetDaily} type="number" placeholder="500" required={platform!=='chatgpt'&&platform!=='criteo'}/>
                <Inp label={(platform==='chatgpt'||platform==='criteo')?t('Toplam Bütçe (esas alınır)'):t('Toplam Bütçe (₺)')} value={budgetTotal} onChange={setBudgetTotal} type="number" placeholder="15000"/>
                <Inp label={t('Başlangıç Tarihi')} value={startDate} onChange={setStartDate} type="date"/>
                <Inp label={t('Bitiş Tarihi')} value={endDate} onChange={setEndDate} type="date"/>
              </div>
            </div>
          </div>
        )}

        {/* Adım 3: Reklam */}
        {step===3&&(
          <div style={{display:'flex',flexDirection:'column' as const,gap:14}}>
            <div style={{fontSize:14,fontWeight:800}}>{t('Reklam İçeriği')}</div>
            <Inp label={platform==='chatgpt'?t('Başlık (en fazla 50 karakter)'):t('Başlık')} value={creative.headline} onChange={v=>setCreative({...creative,headline:v})} placeholder={t('Yaz İndirimleri Başladı!')} required/>
            <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
              <label style={{fontSize:11,fontWeight:700,color:T.textMidAlt}}>{t('Açıklama')} {platform==='google'&&'1'}{platform==='chatgpt'&&t('(en fazla 100 karakter)')}</label>
              <textarea value={creative.description} onChange={e=>setCreative({...creative,description:e.target.value})}
                placeholder={t("Tüm ürünlerde %50'ye varan indirimler...")} rows={3}
                style={{...inputStyle,resize:'vertical' as const}}/>
            </div>
            {platform==='google'&&(
              <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
                <label style={{fontSize:11,fontWeight:700,color:T.textMidAlt}}>{t('Açıklama 2')}<span style={{color:T.redText}}> *</span></label>
                <div style={{fontSize:11,color:T.textDim,marginTop:-2}}>{t('Google Ads reklamlarında en az 2 açıklama zorunludur.')}</div>
                <textarea value={creative.description2} onChange={e=>setCreative({...creative,description2:e.target.value})}
                  placeholder={t('Ücretsiz kargo ve kolay iade avantajlarıyla.')} rows={3}
                  style={{...inputStyle,resize:'vertical' as const}}/>
              </div>
            )}
            <Inp label={t('Hedef URL')} value={creative.url} onChange={v=>setCreative({...creative,url:v})} placeholder="https://example.com/kampanya" required/>
            <div style={{display:'flex',flexDirection:'column' as const,gap:6}}>
              <label style={{fontSize:11,fontWeight:700,color:T.textMidAlt}}>{t('CTA Butonu')}</label>
              <select value={creative.cta} onChange={e=>setCreative({...creative,cta:e.target.value})} style={inputStyle}>
                {['Şimdi Al','Daha Fazla Bilgi','Kaydol','İletişime Geç','İndir','Rezervasyon Yap'].map(c=>(
                  <option key={c} value={c}>{t(c)}</option>
                ))}
              </select>
            </div>
            {platform==='meta'&&<MetaPageSelect clientId={clientId||1} value={(creative as any).page_id||''} onChange={id=>setCreative({...creative,page_id:id} as any)}/>}
            <Inp label={(platform==='chatgpt'||platform==='criteo')?t('Görsel URL'):t('Görsel URL (opsiyonel)')} value={creative.image_url} onChange={v=>setCreative({...creative,image_url:v})} placeholder="https://..." required={platform==='chatgpt'||platform==='criteo'}/>
            {platform==='chatgpt'&&<div style={{fontSize:11,color:T.textDim,marginTop:-8}}>{t('ChatGPT Ads chat-card reklamları görsel zorunlu tutar.')}</div>}
            {platform==='criteo'&&<div style={{fontSize:11,color:T.textDim,marginTop:-8}}>{t("Criteo creative'i görsel zorunlu tutar (indirilip base64 olarak gönderilir).")}</div>}
          </div>
        )}

        {/* Adım 4: Özet */}
        {step===4&&(
          <div style={{display:'flex',flexDirection:'column' as const,gap:14}}>
            <div style={{fontSize:14,fontWeight:800}}>{t('Kampanya Özeti')}</div>
            {[
              {label:'Platform',   value:PLATFORM_INFO[platform]?.label||platform},
              {label:'Kampanya Adı', value:name},
              {label:'Hedef',      value:objectiveLabel(objective, t)},
              {label:'Günlük Bütçe', value:budgetDaily?`₺${budgetDaily}`:'—'},
              {label:'Toplam Bütçe', value:budgetTotal?`₺${budgetTotal}`:'—'},
              {label:'Tarih',      value:startDate&&endDate?`${startDate} → ${endDate}`:startDate||'—'},
              ...(platform==='meta'?[
                {label:'Lokasyon', value:targeting.locations||'—'},
                {label:'Yaş',      value:`${targeting.age_min}-${targeting.age_max}`},
              ]:platform==='google'?[
                {label:'Anahtar Kelime Sayısı', value:String((targeting.keywords||'').split('\n').map((s:string)=>s.trim()).filter(Boolean).length)},
              ]:[]),
              {label:'Başlık',     value:creative.headline||'—'},
              {label:'URL',        value:creative.url||'—'},
              {label:'CTA',        value:creative.cta?t(creative.cta):'—'},
            ].map((r,i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'11px 14px',background:i%2===0?T.subtleBg:T.surface,borderRadius:9,border:`1px solid ${T.tableDivider}`}}>
                <span style={{fontSize:11.5,fontWeight:700,color:T.textMidAlt}}>{t(r.label)}</span>
                <span style={{fontSize:12.5,fontWeight:600,maxWidth:'60%',textAlign:'right' as const,wordBreak:'break-all' as const}}>{r.value}</span>
              </div>
            ))}
            <div style={{display:'flex',flexDirection:'column' as const,gap:6,marginTop:4}}>
              <label style={{fontSize:11,fontWeight:700,color:T.textMidAlt}}>{t('Notlar')}</label>
              <textarea value={notes} onChange={e=>setNotes(e.target.value)} rows={2} placeholder={t('Ek notlar...')} style={{...inputStyle,resize:'vertical' as const}}/>
            </div>
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      <div style={{display:'flex',justifyContent:'space-between',marginTop:14,gap:10}}>
        <button onClick={()=>step===0?setView('list'):setStep(s=>s-1)}
          style={{padding:'10px 20px',background:T.surface,color:T.textMid,border:`1px solid ${T.borderMid}`,borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>
          {step===0?t('İptal'):t('← Geri')}
        </button>
        <div style={{display:'flex',gap:8}}>
          {step===4?(
            <>
              <button onClick={()=>saveDraft('draft')} disabled={saving}
                style={{padding:'10px 20px',background:'var(--py-track-bg)',color:T.textMid,border:`1px solid ${T.border}`,borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>
                {t('Taslak Kaydet')}
              </button>
              <button onClick={()=>saveDraft('review')} disabled={saving}
                style={{padding:'9px 16px',background:T.accent,color:'#fff',border:'none',borderRadius:11,fontSize:13,fontWeight:700,cursor:'pointer'}}>
                {saving?t('Kaydediliyor…'):t('Onaya Gönder →')}
              </button>
            </>
          ):(
            <button onClick={()=>setStep(s=>s+1)} disabled={!canNext}
              style={{padding:'10px 24px',background:canNext?T.accent:T.borderSoft,color:canNext?'var(--py-accent-ink)':T.textDim,border:'none',borderRadius:10,fontSize:13,fontWeight:800,cursor:canNext?'pointer':'not-allowed',transition:'background 0.15s'}}>
              {t('Devam Et →')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
